class MainProductSecondarySlider extends HTMLElement {
  constructor() {
    super();

    this.sliderElement = null;
    this.slider = null;
    this.paginationItems = null;
    this.paginationText = null;
    this.totalSlides = 0;
    this.blazeTrack = null;
    this.blazePaginationContainer = null;

    this.allSlides = [];
    this.allPaginationItems = [];
  }

  connectedCallback() {
    if (!this.slider) {
      this.slider = this.querySelector('.blaze-slider');
      this.paginationItems = this.querySelectorAll('.blaze-pagination-item');
      this.paginationText = this.querySelector('.main-product-secondary__images-pagination');
      this.totalSlides = this.paginationItems.length;
      this.blazeTrack = this.querySelector('.blaze-track');
      this.blazePaginationContainer = this.querySelector('.main-product-secondary__pagination');
    }

    if (typeof BlazeSlider === 'undefined' && !window.BlazeSlider) {
      setTimeout(() => this.connectedCallback(), 100);
      return;
    }

    this.addIndexesToItems();
    this.loadInitialData();
    this.setupSlider();
    this.setupPagination();
    this.setupNavigationButtons();
    this.updateArrows();
    this.updatePaginationText(0);
  }

  addIndexesToItems() {
    this.paginationItems.forEach((item, index) => {
      item.dataset.index = index;
      if (index === 0) {
        item.classList.add('active');
      }
    });

    const slides = this.querySelectorAll('.blaze-slide');
    slides.forEach((slide, index) => {
      const img = slide.querySelector('img');
      if (img) {
        slide.dataset.mediaSrc = img.src;
      }
    });
  }

  loadInitialData() {
    const slides = this.querySelectorAll('.blaze-slide');

    this.allSlides = Array.from(slides).map((slide, index) => ({
      element: slide,
      mediaSrc: slide.dataset.mediaSrc || '',
      index: index,
    }));

    this.allPaginationItems = Array.from(this.paginationItems).map((item, index) => ({
      element: item,
      mediaSrc: item.dataset.mediaSrc || '',
      originalIndex: index,
    }));
  }

  reinitializeSlider() {
    if (this.sliderElement) {
      this.sliderElement.destroy();
    }

    this.setupSlider();
    this.setupNavigationButtons();
    
    if (this.sliderElement) {
      setTimeout(() => {
        if (this.sliderElement && this.sliderElement.stateIndex !== 0) {
          this.goToSlide(0);
        }
        const currentIndex = this.sliderElement.stateIndex || 0;
        this.updatePagination(currentIndex, false);
        this.updatePaginationText(currentIndex);
        this.updateArrows();
      }, 100);
    }
  }

  setupPagination() {
    this.paginationItems.forEach((item, index) => {
      item.addEventListener('click', () => {
        this.goToSlide(index);
        this.updatePagination(index);
        this.updatePaginationText(index);
      });
    });
  }

  setupNavigationButtons() {
    const prevButton = this.querySelector('.blaze-prev');
    const nextButton = this.querySelector('.blaze-next');

    if (prevButton) {
      const newPrevButton = prevButton.cloneNode(true);
      prevButton.parentNode.replaceChild(newPrevButton, prevButton);
      newPrevButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (this.sliderElement && !newPrevButton.disabled) {
          this.sliderElement.prev();
          setTimeout(() => {
            const currentIndex = this.sliderElement.stateIndex || 0;
            this.updatePagination(currentIndex);
            this.updatePaginationText(currentIndex);
            this.updateArrows();
          }, 50);
        }
      });
    }

    if (nextButton) {
      const newNextButton = nextButton.cloneNode(true);
      nextButton.parentNode.replaceChild(newNextButton, nextButton);
      newNextButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (this.sliderElement && !newNextButton.disabled) {
          this.sliderElement.next();
          setTimeout(() => {
            const currentIndex = this.sliderElement.stateIndex || 0;
            this.updatePagination(currentIndex);
            this.updatePaginationText(currentIndex);
            this.updateArrows();
          }, 50);
        }
      });
    }
  }

  setupSlider() {
    const BlazeSliderClass = window.BlazeSlider || (typeof BlazeSlider !== 'undefined' ? BlazeSlider : null);
    
    if (!BlazeSliderClass) {
      return;
    }

    this.sliderElement = new BlazeSliderClass(this.slider, {
      all: {
        transitionDuration: 300,
        draggable: true,
        slidesToShow: 1,
        slideGap: '5px',
        loop: false,
      },
      '(max-width: 768px)': {
        transitionDuration: 300,
        transitionTimingFunction: 'cubic-bezier(0.45, 0.1, 0.45, 0.5)',
        draggable: true,
      },
    });

    const self = this;
    let previousStateIndex = this.sliderElement.stateIndex || 0;
    
    this.sliderElement.onSlide((index) => {
      const currentIndex = typeof index === 'number' ? index : (self.sliderElement.stateIndex || 0);
      self.updatePagination(currentIndex);
      self.updatePaginationText(currentIndex);
      self.updateArrows();
      previousStateIndex = currentIndex;

      self.dispatchEvent(
        new CustomEvent('slider-change', {
          detail: {
            index: currentIndex,
          },
        })
      );
    });
    
    const trackContainer = this.querySelector('.blaze-track-container');
    if (trackContainer) {
      trackContainer.addEventListener('transitionend', () => {
        if (self.sliderElement) {
          const currentIndex = self.sliderElement.stateIndex || 0;
          if (currentIndex !== previousStateIndex) {
            self.updatePagination(currentIndex);
            self.updatePaginationText(currentIndex);
            self.updateArrows();
            previousStateIndex = currentIndex;
          }
        }
      });
      
      let checkInterval = null;
      const startMonitoring = () => {
        if (checkInterval) return;
        checkInterval = setInterval(() => {
          if (self.sliderElement) {
            const currentIndex = self.sliderElement.stateIndex || 0;
            if (currentIndex !== previousStateIndex) {
              self.updatePagination(currentIndex);
              self.updatePaginationText(currentIndex);
              self.updateArrows();
              previousStateIndex = currentIndex;
            }
          }
        }, 100);
      };
      
      const stopMonitoring = () => {
        if (checkInterval) {
          clearInterval(checkInterval);
          checkInterval = null;
        }
      };
      
      trackContainer.addEventListener('touchstart', startMonitoring);
      trackContainer.addEventListener('mousedown', startMonitoring);
      trackContainer.addEventListener('touchend', () => {
        setTimeout(stopMonitoring, 500);
      });
      trackContainer.addEventListener('mouseup', () => {
        setTimeout(stopMonitoring, 500);
      });
    }
  }

  updatePagination(index, shouldScroll = true) {
    if (!this.paginationItems || this.paginationItems.length === 0) {
      return;
    }
    
    const validIndex = Math.max(0, Math.min(index, this.paginationItems.length - 1));
    
    this.paginationItems.forEach((item) => {
      item.classList.remove('active');
    });
    
    if (this.paginationItems[validIndex]) {
      this.paginationItems[validIndex].classList.add('active');
      if (shouldScroll && !this.isElementInViewport(this.paginationItems[validIndex])) {
        this.paginationItems[validIndex].scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center',
        });
      }
    }
  }

  updateArrows() {
    if (!this.sliderElement) return;

    const states = this.sliderElement.states;
    const stateIndex = this.sliderElement.stateIndex;
    const config = this.sliderElement.config;

    const lastStateIndex = states.length - 1;
    const isLoop = config.loop;

    const prevButton = this.querySelector('.blaze-prev');
    const nextButton = this.querySelector('.blaze-next');

    if (!prevButton || !nextButton) return;
    
    if (isLoop) {
      prevButton.disabled = false;
      nextButton.disabled = false;
      return;
    }

    prevButton.disabled = stateIndex === 0;
    nextButton.disabled = stateIndex === lastStateIndex;
  }

  isElementInViewport(element) {
    const rect = element.getBoundingClientRect();
    const container = this.blazePaginationContainer.getBoundingClientRect();

    return (
      rect.left >= container.left &&
      rect.right <= container.right &&
      rect.top >= container.top &&
      rect.bottom <= container.bottom
    );
  }

  updatePaginationText(index) {
    if (this.paginationText) {
      this.paginationText.textContent = `${index + 1}/${this.totalSlides}`;
    }
  }

  goToSlide(index) {
    if (this.sliderElement) {
      const currentState = this.sliderElement.stateIndex;
      const diff = index - currentState;

      if (diff > 0) {
        this.sliderElement.next(diff);
      } else if (diff < 0) {
        this.sliderElement.prev(Math.abs(diff));
      }
    }
  }

  updateSliderImages(newImages) {
    if (!this.blazeTrack) return;

    this.blazeTrack.innerHTML = '';
    
    newImages.forEach((imgSrc, index) => {
      const slideDiv = document.createElement('div');
      slideDiv.className = 'blaze-slide';
      slideDiv.dataset.mediaSrc = imgSrc;
      
      const img = document.createElement('img');
      img.src = imgSrc;
      img.alt = 'Product image';
      img.width = '100%';
      img.height = 'auto';
      img.loading = index === 0 ? 'eager' : 'lazy';
      
      slideDiv.appendChild(img);
      this.blazeTrack.appendChild(slideDiv);
    });

    this.loadInitialData();
    this.reinitializeSlider();
  }

  updatePaginationThumbnails(newImages) {
    if (!this.blazePaginationContainer) return;

    this.blazePaginationContainer.innerHTML = '';
    
    newImages.forEach((imgSrc, index) => {
      const paginationDiv = document.createElement('div');
      paginationDiv.className = 'blaze-pagination-item';
      if (index === 0) paginationDiv.classList.add('active');
      paginationDiv.dataset.index = index;
      paginationDiv.dataset.mediaSrc = imgSrc;
      
      const img = document.createElement('img');
      img.src = imgSrc;
      img.alt = 'Thumbnail';
      img.width = '100';
      img.height = 'auto';
      img.loading = 'lazy';
      
      paginationDiv.appendChild(img);
      this.blazePaginationContainer.appendChild(paginationDiv);
    });

    this.paginationItems = this.querySelectorAll('.blaze-pagination-item');
    this.totalSlides = this.paginationItems.length;
    this.setupPagination();
    this.updatePagination(0, false);
    this.updatePaginationText(0);
  }
}

if (customElements.get('main-product-secondary-slider') === undefined) {
  customElements.define('main-product-secondary-slider', MainProductSecondarySlider);
}

